module.exports = __webpack_public_path__ + "static/img/book29.a05a1a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book29.jpg
// module id = O7/+
// module chunks = 1